/**
 * Mention Parser - Regex Constants
 *
 * All regex patterns for structured and legacy mention tokens.
 */

// ─── Structured mention tokens ────────────────────────────────────────────────
// Format: @[Display Name](userId)
// Example: @[Omid Ahmed](abc123xyz)

/**
 * Matches structured mention tokens: @[Name](userId)
 * - Group 1: display name (anything except ']')
 * - Group 2: user ID (anything except ')')
 */
export const STRUCTURED_MENTION_REGEX = /@\[([^\]]+)\]\(([^)]+)\)/g;

/**
 * Stateless version for .test() calls (no /g flag).
 */
export const STRUCTURED_MENTION_REGEX_TEST = /@\[([^\]]+)\]\(([^)]+)\)/;

// ─── Legacy plain @mentions ───────────────────────────────────────────────────
// Format: @username  (no spaces allowed in the username portion)

/**
 * Regular expression to match legacy @mentions (global — used with str.match() only).
 * IMPORTANT: Never use this with regex.test() or regex.exec() — the /g flag makes
 * the regex stateful (lastIndex advances on each call), which causes alternating
 * true/false results when test() is called repeatedly.
 */
export const LEGACY_MENTION_REGEX = /@([a-zA-Z0-9_]+)/g;

/**
 * Stateless (no /g flag) regex for boolean presence checks via .test().
 * Kept for potential future use (e.g., isolated legacy mention checks).
 */
// eslint-disable-next-line no-unused-vars
export const LEGACY_MENTION_REGEX_TEST = /@([a-zA-Z0-9_]+)/;

/**
 * Combined test regex — checks for EITHER structured or legacy mentions.
 */
export const ANY_MENTION_REGEX_TEST = /(@\[[^\]]+\]\([^)]+\)|@[a-zA-Z0-9_]+)/;

/**
 * Validates userId format in structured tokens.
 */
export const STRUCTURED_MENTION_USER_ID_REGEX = /^[A-Za-z0-9_-]{3,128}$/;
